import SettingsCog from "./SettingsCog";
export default SettingsCog;
